import { Global } from "@emotion/react";
import base from "./base";

const GlobalStyles = () => <Global styles={base} />;

export default GlobalStyles;
